<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="200px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="设备IMEI号" prop="deviceSerial">
              <el-input clearable disabled v-model="form.deviceSerial" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备型号" prop="deviceModelName">
              <el-input clearable disabled v-model="form.deviceModelName" maxlength="100"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="设备版本" prop="firewareVersion">
              <el-input clearable disabled v-model="form.firewareVersion" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备SIM卡号" prop="simCard">
              <el-input clearable disabled v-model="form.simCard" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="心率上限" prop="heartRateThresholdUpper">
              <el-input clearable disabled v-model="form.heartRateThresholdUpper" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="心率下限" prop="heartRateThresholdLower">
              <el-input clearable disabled v-model="form.heartRateThresholdLower" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运营商" prop="telecomOperator">
              <el-input clearable disabled v-model="form.telecomOperator" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计步开关" prop="stepFlag">
              <el-select disabled  v-model="form.stepFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姿态异常监测" prop="poseMonitorFlag">
              <el-select disabled  v-model="form.poseMonitorFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地址" prop="addr">
              <el-input clearable disabled v-model="form.addr" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计步目标" prop="stepTarget">
              <el-input clearable disabled v-model="form.stepTarget" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="情景模式" prop="sceneMode">
              <el-input clearable disabled v-model="form.sceneMode" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计步频率" prop="stepFrequency">
              <el-input clearable disabled v-model="form.stepFrequency" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="智能省电模式" prop="powerSavingModeFlag">
              <el-select disabled  v-model="form.powerSavingModeFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="睡眠开关" prop="sleepModeFlag">
              <el-select disabled  v-model="form.sleepModeFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="舒张压日常值" prop="diastolicBloodPressureDailyValue">
              <el-input clearable disabled v-model="form.diastolicBloodPressureDailyValue" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收缩压日常值" prop="systolicBloodPressureDailyValue">
              <el-input clearable disabled v-model="form.systolicBloodPressureDailyValue" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="睡眠开始时间" prop="sleepStart">
              <el-input clearable disabled v-model="form.sleepStart" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="睡眠结束时间" prop="sleepEnd">
              <el-input clearable disabled v-model="form.sleepEnd" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="舒张压下限阈值" prop="diastolicBloodPressureThresholdLower">
              <el-input clearable disabled v-model="form.diastolicBloodPressureThresholdLower" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收缩压上限阈值" prop="systolicBloodPressureThresholdUpper">
              <el-input clearable disabled v-model="form.systolicBloodPressureThresholdUpper" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="心率开关" prop="heartRateFlag">
              <el-select disabled  v-model="form.heartRateFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="心率/血压/血氧定时测量开关" prop="heartRateTimedMonitorFlag">
              <el-select disabled  v-model="form.heartRateTimedMonitorFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="轨迹开关" prop="stepPathFlag">
              <el-select disabled  v-model="form.stepPathFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="心率上报频率" prop="heartRateUploadFrequency">
              <el-input clearable disabled v-model="form.heartRateUploadFrequency" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="定位上报频率" prop="gpsUploadFrequency">
              <el-input clearable disabled v-model="form.gpsUploadFrequency" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="来电接听模式" prop="callRecieveMode">
              <el-input clearable disabled v-model="form.callRecieveMode" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="紧急呼叫模式" prop="sosMode">
              <el-input clearable disabled v-model="form.sosMode" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="GPS开关" prop="gpsFlag">
              <el-select disabled  v-model="form.gpsFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="佩戴状态测量开关" prop="wearStatusMeasureFlag">
              <el-select disabled  v-model="form.wearStatusMeasureFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="佩戴状态测量频率（分钟）" prop="wearStatusMeasureFrequency">
              <el-input clearable disabled v-model="form.wearStatusMeasureFrequency" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="语音提醒答复开关" prop="voiceRemindReplyFlag">
              <el-select disabled  v-model="form.voiceRemindReplyFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="短信上传开关" prop="smsUploadFlag">
          
              <el-select disabled  v-model="form.smsUploadFlag" style="width: 100%" >
              <el-option
                v-for="item in switchDic"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运动心率上限阈值" prop="sportHeartRateThresholdUpper">
              <el-input clearable disabled v-model="form.sportHeartRateThresholdUpper" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运动心率下限阈值" prop="sportHeartRateThresholdLower">
              <el-input clearable disabled v-model="form.sportHeartRateThresholdLower" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import {getSmartDeviceDataConfig } from '@/api/nursingHome/elderDevice';

export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [],
      switchDic:[
        {
          id:1,
          name:"开"
        },
        {
          id:0,
          name:"关"
        }
      ],
      form: {
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode: '',
      },
      formRules: {
       
        consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
     initData() {
      getSmartDeviceDataConfig({id: this.row.id}).then((res) => {
        this.form = res.data
      })
     },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
